import script from "./ShoppingCartSidebar.vue?vue&type=script&setup=true&lang=ts"
export * from "./ShoppingCartSidebar.vue?vue&type=script&setup=true&lang=ts"

import "./ShoppingCartSidebar.vue?vue&type=style&index=0&id=36d47d20&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36d47d20"]])

export default __exports__